import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito diagnóstico médico?', 'No. Podés aplicarlo desde tu casa con información clara. No reemplaza la consulta médica, pero tampoco la necesita para arrancar.'], ['¿Los ingredientes son difíciles de conseguir?', 'No. Todo está disponible en cualquier supermercado o verdulería argentina. Sin productos importados ni suplementos costosos.'], ['¿Cuándo veo resultados?', 'La mayoría nota cambios entre el Día 7 y el Día 14. Los resultados profundos se consolidan en los 30 días completos.'], ['¿La garantía es real?', 'Sí. 30 días, 100% de devolución, sin preguntas ni letra chica.'], ['¿Es 100% digital?', 'Sí. Recibís todo por email en menos de 5 minutos. Funciona en celular, tablet y computadora.']];
const purchases = [['Carmen R.', 'Buenos Aires'], ['Roberto S.', 'Córdoba'], ['Mirta P.', 'Rosario'], ['Diego F.', 'Mendoza']];
export function ClosingSections() {
  const [open, setOpen] = useState<number | null>(null);
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-17">
        <div className="mx-auto max-w-3xl text-center" data-id="element-18">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" data-id="element-19" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-20">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-21">
            <p className="text-slate-300" data-id="element-22">Seguís el sistema.</p>
            <p className="mt-4 text-slate-300" data-id="element-23">
              Si en 30 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-24">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-25">
              sin formularios, sin drama.
            </p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-26">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>
      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-27">
        <div className="mx-auto max-w-3xl" data-id="element-28">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-29">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-30">
            {faqs.map(([question, answer], index) => <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-31">
                <button onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-32">
                  <span data-id="element-33">{question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform ${open === index ? 'rotate-180' : ''}`} data-id="element-34" />
                </button>
                <AnimatePresence data-id="element-35">
                  {open === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} data-id="element-36">
                      <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-37">
                        {answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-38">
        <div className="mx-auto max-w-4xl" data-id="element-39">
          <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-40">
            ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
          </h2>
          <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-41">
            {['Otro año con el omeprazol que sabés que te hace mal', 'Noches interrumpidas por el ardor que no te deja descansar', 'Reuniones y asados a los que dejás de ir por miedo', 'Plata gastada en médicos y estudios sin solución real', 'Cansancio y neblina mental que todos atribuyen a la edad', 'Otro año con la misma dependencia y la misma frustración'].map(item => <p key={item} className="border-b border-[#1a4a2e] border-l-4 border-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium text-white last:border-b-0" data-id="element-42">
                × &nbsp;{item}
              </p>)}
          </div>
          <p className="mt-12 text-center text-xl font-bold" data-id="element-43">
            El próximo lunes puede ser completamente diferente.
          </p>
          <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-44">
            “Tu intestino no está roto. Solo está esperando la hoja de ruta
            correcta.”
          </p>
        </div>
      </section>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-45">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-46">
          PROTOCOLO BARRIDO INTESTINAL™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-47">
          El sistema de barrido intestinal para hombres y mujeres que buscan
          recuperar una digestión liviana.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-48">
          Porque tu intestino no está roto. Solo está esperando que le des lo
          que realmente necesita.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-49">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-50">
            soportebiomalivido@gmail.com
          </a>
          <a className="hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-51">
            @biomalivido
          </a>
          <a className="hover:text-brand-light" href="https://www.biomalivido.com" data-id="element-52">
            www.biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-53">
          © BIOMA LÍVIDO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>
      <AnimatePresence data-id="element-54">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-55">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-56">
              <CheckCircle2Icon className="h-4 w-4" data-id="element-57" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-58">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-59">
              compró Protocolo Barrido Intestinal™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-60">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}